import Command from './command';
import CommandResult from './command-result';
export default Command.extend({
  processZeroWidth() {
    return this._selectEntity();
  },
  processSingleBlock() {
    return this._selectEntity();
  },
  processMultiBlock() {
    return this._selectEntity();
  },
  _selectEntity() {
    let entitySelection = this.getSelectionOfEntityById(this.get('options.id'));
    if (!entitySelection) {
      return CommandResult.create({
        foundEntity: false
      });
    }
    this.get('selection').setProperties(entitySelection);
    return CommandResult.create({
      foundEntity: true
    });
  },
  getSelectionOfEntityById(id) {
    let i, j;
    let entity;
    let block;
    let itemBlock;
    let itemBlockList;
    let blockList = this.get('blockList');
    for (i = 0; i < blockList.get('length'); i++) {
      block = blockList.objectAt(i);
      if (!block.get('blockList')) {
        entity = block.findEntityById(id);
        if (entity) {
          return this._generateSelectionObject(i, 0, entity.get('startIndex'), i, 0, entity.get('endIndex'));
        }
      } else {
        itemBlockList = block.get('blockList');
        for (j = 0; j < itemBlockList.get('length'); j++) {
          itemBlock = itemBlockList.objectAt(j);
          entity = itemBlock.findEntityById(id);
          if (entity) {
            return this._generateSelectionObject(i, j, entity.get('startIndex'), i, j, entity.get('endIndex'));
          }
        }
      }
    }
  },
  _generateSelectionObject(startBlockIndex, startItemIndex, startPositionIndex, endBlockIndex, endItemIndex, endPositionIndex) {
    return {
      startBlockIndex,
      startItemIndex,
      startPositionIndex,
      endBlockIndex,
      endItemIndex,
      endPositionIndex
    };
  }
});